import React, { useEffect, useState } from "react";

interface props {
    name: string,
    value: string,
    label?: string,
    placeholder?: string,
    lang?: string,
    onChange: (changeValue: string) => void
}

const TextAreaInput  = (props: props) => {

    const groupTextId = props.name + 'label';
    const inputId = props.name + '-input';

    const [inputValue, setInputValue] = useState<string>(props.value);
    const [inputLabel, setInputLabel] = useState<string>('');
    const [inputPlaceholder, setInputPlaceholder] = useState<string>('');
    const [inputLang, setInputLang] = useState<string>('');
    const [inputSpellcheck, setInputSpellcheck] = useState<boolean>(false);

    const handleChange = (event: any) => {
        const newValue = event.target.value;
        setInputValue(newValue);
        props.onChange(newValue);
    };

    useEffect(() => {
        if (typeof props.label !== 'undefined') {
            setInputLabel(props.label);
        }

        if (typeof props.placeholder !== 'undefined') {
            setInputPlaceholder(props.placeholder);
        }

        if (typeof props.lang !== 'undefined' && props.lang !== '') {
            setInputLang(props.lang);
            setInputSpellcheck(true);
        } else {
            setInputLang('');
            setInputSpellcheck(false);
        }

        setInputValue(props.value);
    }, [props]);

    
    return (
        <div className="input-group formElement">
            <span className="input-group-text text-start align-items-start" id={groupTextId}>{inputLabel}</span>
            <textarea id={inputId}
                name={inputId}
                className="form-control"
                placeholder={inputPlaceholder}
                aria-label={inputLabel}
                aria-describedby={groupTextId}
                value={inputValue}
                onChange={handleChange}
                lang={inputLang}
                spellCheck={inputSpellcheck}
            ></textarea>
        </div>
    );
};

export { TextAreaInput }
